<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p35"><span><a href="#/Contents#rp35">CREAMY BROCCOLI-POTATO SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>This soup can also be served cold. Stir 1 tablespoon lemon juice and ¼ cup additional Chicken Stock into soup; refrigerate until chilled. Garnish each bowl of soup with a lemon slice.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>4 medium leeks (white parts only), sliced</span></p>
<p class="hang"><span>2 teaspoons margarine or butter</span></p>
<p class="hang"><span>3 cups Chicken Stock (see <a href="#/Chapter012#p2">p. 2</a>)</span></p>
<p class="hang"><span>3½ cups diced peeled potatoes</span></p>
<p class="hang"><span>1 quart thickly sliced broccoli</span></p>
<p class="hang"><span>1¼ cups whole milk</span></p>
<p class="hang"><span>Salt and white pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Sauté leeks in margarine in large saucepan until leeks are tender, but not browned, about 10 minutes. Add stock, potatoes, and broccoli; heat to boiling. Reduce heat and simmer, covered, until vegetables are tender, about 10 minutes. Process soup in food processor or blender until smooth; return to saucepan. Stir in milk and heat to boiling; reduce heat and simmer, covered, 5 minutes. Season to taste with salt and white pepper.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 148</span></p>
<p class="per1"><span>% calories from fat: 15</span></p>
<p class="per1"><span>Protein (g): 6.3</span></p>
<p class="per1"><span>Carbohydrate (g): 26.9</span></p>
<p class="per1"><span>Fat (g): 2.5</span></p>
<p class="per1"><span>Saturated fat (g): 1</span></p>
<p class="per1"><span>Cholesterol (mg): 5.2</span></p>
<p class="per1"><span>Sodium (mg): 175</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 1.5</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0217.vue?9f5ccc72